export const ExternalApi = {
  GetAddressByPostalCode: (code: string) => ({
    baseUrl: 'https://www.onemap.gov.sg/api/',
    path: `common/elastic/search?searchVal=${code}&returnGeom=Y&getAddrDetails=Y&pageNum=1`
  })
};
